import { z } from 'zod';

export const changeZakatDateGetResponseSchema = z.object({
  data: z.object({ notify: z.boolean().optional(), zakat_date: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
